// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React from 'react';
import { Link } from 'react-router-dom';
import { parseDuration } from '../../../../../../../lib/utility';
import HyperlinkLinkIcon from '../../../../../../../assets/images/hyperlink-link-icon.svg';
import { TextModule as TextModuleType } from '../../../../../../../types/Model';

import { S } from './styles';

interface TextModuleProps {
  active: boolean;
  module: TextModuleType;
  to: string;
}

const TextModule: React.FC<TextModuleProps> = (props):JSX.Element => {
  const {
    active,
    module: {
      name,
      type,
    },
    to
  } = props;

  return (
    <S.Container>
      <S.Link as={Link} to={to} active={active}>
        <S.TextContainer>
          <S.Icon type={type}/>
          <S.TextModuleTitle>{name}</S.TextModuleTitle>
        </S.TextContainer>
      </S.Link>
    </S.Container>
  );
}

export { TextModule as default };
